import { createApiRef } from '@backstage/core-plugin-api';

const sonarQubeApiRef = createApiRef({
  id: "plugin.sonarqube.service"
});

const SONARQUBE_PROJECT_KEY_ANNOTATION = "sonarqube.org/project-key";
const isSonarQubeAvailable = (entity) => {
  var _a;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[SONARQUBE_PROJECT_KEY_ANNOTATION]);
};

const SONARQUBE_PROJECT_INSTANCE_SEPARATOR = "/";
const useProjectInfo = (entity) => {
  var _a;
  let projectInstance = void 0;
  let projectKey = void 0;
  const annotation = (_a = entity == null ? void 0 : entity.metadata.annotations) == null ? void 0 : _a[SONARQUBE_PROJECT_KEY_ANNOTATION];
  if (annotation) {
    const instanceSeparatorIndex = annotation.indexOf(
      SONARQUBE_PROJECT_INSTANCE_SEPARATOR
    );
    if (instanceSeparatorIndex > -1) {
      projectInstance = annotation.substring(0, instanceSeparatorIndex);
      projectKey = annotation.substring(instanceSeparatorIndex + 1);
    } else {
      projectKey = annotation;
    }
  }
  return { projectInstance, projectKey };
};

export { SONARQUBE_PROJECT_KEY_ANNOTATION, isSonarQubeAvailable, sonarQubeApiRef, useProjectInfo };
//# sourceMappingURL=index.esm.js.map
